"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dropDown = require("@clayui/drop-down");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["className", "messages", "trigger"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @deprecated since v3.84.0 - use `Picker` component instead.
 */
var ClayPaginationBarDropDown = function ClayPaginationBarDropDown(_ref) {
  var className = _ref.className,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? 'Items Per Page' : _ref$messages,
      trigger = _ref.trigger,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, _extends({
    className: (0, _classnames.default)(className, 'pagination-items-per-page'),
    trigger: /*#__PURE__*/_react.default.cloneElement(trigger, {
      'aria-label': messages
    })
  }, otherProps));
};

var _default = ClayPaginationBarDropDown;
exports.default = _default;